/* Modulregister (ARCHITEKTUR.md, Abschnitt 5). Ein neues Modul: Ordner unter modules/, modul.ts, hier eintragen.
   Reihenfolge: Kern zuerst. Spätere Module überschreiben Routen und Navigation des Kerns mit demselben Pfad (zum Beispiel „/“). */
import { kern } from "../kern/kernModul";
import type { Modul } from "../kern/modul";
import { aufgaben } from "./aufgaben/modul";
import { finanzen } from "./finanzen/modul";
import { redaktion } from "./redaktion/modul";
import { sitzung } from "./sitzung/modul";
import { termine } from "./termine/modul";
import { zugaenge } from "./zugaenge/modul";

export const MODULE: readonly Modul[] = [kern, aufgaben, finanzen, sitzung, termine, zugaenge, redaktion];
